import { useTranslation } from 'react-i18next';
// material
import { enUS, esES /* ptBR */ } from '@mui/material/locale';

// ----------------------------------------------------------------------

const LANGS = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/static/icons/ic_flag_en.svg'
  },
  {
    label: 'Español',
    value: 'es',
    systemValue: esES,
    icon: '/static/icons/ic_flag_es.svg'
  }
  /* {
    label: 'Português',
    value: 'br',
    systemValue: ptBR,
    icon: '/static/icons/ic_flag_br.svg'
  } */
];

export default function useTranslations() {
  const { i18n, t: translate } = useTranslation();
  const langStorage = localStorage.getItem('i18nextLng');
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage) || LANGS[1];

  const handleChangeLanguage = (newlang: string) => {
    i18n.changeLanguage(newlang);
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate,
    currentLang,
    allLang: LANGS
  };
}
